import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssignMemberToTeamsMutationVariables = Types.Exact<{
  data: Types.AssignTeamsToMemberInput;
}>;


export type AssignMemberToTeamsMutation = { __typename?: 'Mutation', assignTeamsToMember: { __typename?: 'OrganisationMemberTeamsMembership', id: string, teamsMembership: Array<{ __typename?: 'OrganisationTeamMember', id: string, team: { __typename?: 'OrganisationMemberUser', id: string } }> } };


export const AssignMemberToTeamsDocument = gql`
    mutation AssignMemberToTeams($data: AssignTeamsToMemberInput!) {
  assignTeamsToMember(data: $data) {
    id
    teamsMembership {
      id
      team {
        id
      }
    }
  }
}
    `;
export type AssignMemberToTeamsMutationFn = Apollo.MutationFunction<AssignMemberToTeamsMutation, AssignMemberToTeamsMutationVariables>;

/**
 * __useAssignMemberToTeamsMutation__
 *
 * To run a mutation, you first call `useAssignMemberToTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMemberToTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMemberToTeamsMutation, { data, loading, error }] = useAssignMemberToTeamsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAssignMemberToTeamsMutation(baseOptions?: Apollo.MutationHookOptions<AssignMemberToTeamsMutation, AssignMemberToTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignMemberToTeamsMutation, AssignMemberToTeamsMutationVariables>(AssignMemberToTeamsDocument, options);
      }
export type AssignMemberToTeamsMutationHookResult = ReturnType<typeof useAssignMemberToTeamsMutation>;
export type AssignMemberToTeamsMutationResult = Apollo.MutationResult<AssignMemberToTeamsMutation>;
export type AssignMemberToTeamsMutationOptions = Apollo.BaseMutationOptions<AssignMemberToTeamsMutation, AssignMemberToTeamsMutationVariables>;